export default __webpack_public_path__ + "static/media/layout_dark_v2_info_eight_cogfunc.094a0204.svg";